var map = {
	"./404.svg": "sEM+",
	"./bug.svg": "SVqS",
	"./build.svg": "HZxw",
	"./button.svg": "NHTG",
	"./cascader.svg": "2VtW",
	"./chart.svg": "RjYk",
	"./checkbox.svg": "LHos",
	"./clipboard.svg": "KO/S",
	"./code.svg": "IX5Q",
	"./color.svg": "fnP5",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./date-range.svg": "yBtI",
	"./date.svg": "Ve8B",
	"./dict.svg": "OyZ9",
	"./documentation.svg": "zUKd",
	"./download.svg": "+H2/",
	"./drag.svg": "vRhf",
	"./druid.svg": "yII6",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./github.svg": "z6R7",
	"./guide.svg": "z74U",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./input.svg": "k6mQ",
	"./international.svg": "SBEl",
	"./job.svg": "sieq",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./log.svg": "8uFK",
	"./login-mall.svg": "xzZT",
	"./logininfor.svg": "htrW",
	"./marker.svg": "0+/s",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./monitor.svg": "Lu+8",
	"./nested.svg": "798r",
	"./number.svg": "tyP3",
	"./online.svg": "lWBX",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./phone.svg": "7pRf",
	"./post.svg": "6LpI",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./qq.svg": "R2jY",
	"./question.svg": "noTa",
	"./radio.svg": "l4Qn",
	"./rate.svg": "h/JX",
	"./redis-list.svg": "7Ovd",
	"./redis.svg": "riER",
	"./row.svg": "CPNK",
	"./search.svg": "Bx0U",
	"./select.svg": "FK+b",
	"./server.svg": "2Sb8",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./skill.svg": "NpjO",
	"./slider.svg": "rMcP",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./star.svg": "60zo",
	"./swagger.svg": "u+kp",
	"./switch.svg": "qyXC",
	"./system.svg": "Jax1",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./textarea.svg": "zlq4",
	"./theme.svg": "hdtf",
	"./time-range.svg": "6py6",
	"./time.svg": "RJM1",
	"./tool.svg": "Y44e",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./upload.svg": "P/TB",
	"./user.svg": "VdD3",
	"./validCode.svg": "5eKK",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 138